const SVGIcon = ({ icon: Icon, fallback }) => {
    if (Icon) {
        return <Icon />;
    } else {
        return fallback ? <fallback /> : null;
    }
};

export default SVGIcon;